class BundleIdManager {
  constructor() {
    this.idCounter = 0;
    this.usedIds = new Set();
  }

  generateUniqueId() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    }

    const timestamp = Date.now().toString(36);
    const counter = (++this.idCounter).toString(36);
    const random = Math.random().toString(36).substr(2, 5);

    return `bundle-${timestamp}-${counter}-${random}`;
  }

  updateIdsInHtml(htmlString, uniqueId, productHandle) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;

    const mainContainer = tempDiv.querySelector('.js-smp-bundle-snippet');
    if (mainContainer) {
      mainContainer.setAttribute('data-unique-id', uniqueId);
    }

    const inputs = tempDiv.querySelectorAll('input[type="radio"]');
    inputs.forEach((input) => {
      const oldId = input.id;
      const oldName = input.name;

      if (oldId) {
        const newId = `${oldId}-${uniqueId}`;
        input.id = newId;

        const label = tempDiv.querySelector(`label[for="${oldId}"]`);
        if (label) {
          label.setAttribute('for', newId);
        }
      }

      if (oldName) {
        const newName = `${oldName}-${uniqueId}`;
        input.name = newName;
      }
    });

    // const elementsWithIds = tempDiv.querySelectorAll('[id]');
    // elementsWithIds.forEach((element) => {
    //   if (element.tagName.toLowerCase() !== 'input') {
    //     const oldId = element.id;
    //     if (oldId && !oldId.includes(uniqueId)) {
    //       element.id = `${oldId}-${uniqueId}`;
    //     }
    //   }
    // });

    const labels = tempDiv.querySelectorAll('label[for]');
    labels.forEach((label) => {
      const forValue = label.getAttribute('for');
      if (forValue && !forValue.includes(uniqueId)) {
        label.setAttribute('for', `${forValue}-${uniqueId}`);
      }
    });

    return tempDiv.innerHTML;
  }

  initializeExistingIds(container, uniqueId) {
    const labelMap = new Map();

    const labels = container.querySelectorAll('label[for]');
    labels.forEach((label) => {
      const forValue = label.getAttribute('for');
      if (forValue) {
        labelMap.set(forValue, label);
      }
    });

    const inputs = container.querySelectorAll('input[type="radio"]');
    inputs.forEach((input) => {
      const oldId = input.id;
      const oldName = input.name;

      if (oldId && !oldId.includes(uniqueId)) {
        const newId = `${oldId}-${uniqueId}`;
        input.id = newId;

        const label = labelMap.get(oldId);
        if (label) {
          label.setAttribute('for', newId);
        }
      }

      if (oldName && !oldName.includes(uniqueId)) {
        const newName = `${oldName}-${uniqueId}`;
        input.name = newName;
      }
    });

    const otherElements = container.querySelectorAll('[id]:not(input)');
    otherElements.forEach((element) => {
      const oldId = element.id;
      if (oldId && !oldId.includes(uniqueId)) {
        element.id = `${oldId}-${uniqueId}`;
      }
    });
  }

  processProductForm(container, productHandle) {
    const uniqueId = this.generateUniqueId();

    container.setAttribute('data-unique-id', uniqueId);

    this.initializeExistingIds(container, uniqueId);

    return uniqueId;
  }

  processFetchedHtml(htmlString, productHandle) {
    const uniqueId = this.generateUniqueId();
    const processedHtml = this.updateIdsInHtml(htmlString, uniqueId, productHandle);



    return {
      processedHtml,
      uniqueId,
    };
  }
}

window.bundleIdManager = new BundleIdManager();

if (typeof module !== 'undefined' && module.exports) {
  module.exports = BundleIdManager;
}
